import React, { useState } from 'react';
import classNames from 'classnames';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import amber from '@material-ui/core/colors/amber';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import WarningIcon from '@material-ui/icons/Warning';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/core/styles';

import { useDispatch } from 'react-redux';
import * as actions from '../../../state';

const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon,
};

const styles = (theme) => ({
  error: {
    backgroundColor: theme.palette.error.dark,
  },
  warning: {
    backgroundColor: amber[700],
  },
  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing(1),
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
});

/**
 *
 * @toasterType 'success', 'warning', 'error', 'info'
 * @toasterMessage string
 */

function Toaster({
  classes,
  toasterType,
  toasterMessage,
  toasterAction,
}) {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(true);

  const Icon = variantIcon[toasterType];

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);

    dispatch(actions.showToaster({
      show: false,
      message: '',
      type: '',
    }));
  };

  const action = toasterAction || (
    <IconButton
      key="close"
      aria-label="Close"
      color="inherit"
      style={{ color: '#fff' }}
      className={classes.close}
      onClick={handleClose}
    >
      <CloseIcon className={classes.icon} />
    </IconButton>
  );

  return (
    <div>
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        open={open}
        autoHideDuration={5500}
        onClose={handleClose}
        style={{ zIndex: 88888888888888 }}
      >
        <SnackbarContent
          className={classNames(classes[toasterType])}
          aria-describedby="client-snackbar"
          message={(
            <span id="client-snackbar" className={classes.message}>
              <Icon className={classNames(classes.icon, classes.iconVariant)} />
              {toasterMessage}
            </span>
          )}
          action={action}
        />
      </Snackbar>
    </div>
  );
}

export default withStyles(styles)(Toaster);
